import { highlightParts } from "../lib/format";

/** Text with the given terms marked where it uses them; everything is rendered as text, never HTML. */
export function Highlight({ text, terms, as = "mark" }: { text: string; terms: string[]; as?: "mark" | "term" }) {
  return (
    <>
      {highlightParts(text, terms).map((p, i) =>
        p.mark ? (
          as === "term" ? (
            <em key={i} className="term">
              {p.text}
            </em>
          ) : (
            <mark key={i}>{p.text}</mark>
          )
        ) : (
          p.text
        ),
      )}
    </>
  );
}
